// extracted by mini-css-extract-plugin
export var closeButton = "_ki-2";
export var closeButtonIcon = "_ki-3";
export var lightboxContent = "_ki-1";
export var lightboxOverlay = "_ki-0";